// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__vNJgM","body":"Layout_body__oMw0b","contentContainer":"Layout_contentContainer__5mkCb"};